import {createReducer} from "redux-act";
import {fetchSquadsJsonSuccess} from "apps/DRAW_PREDICTOR/modules/actions";
import {Confederation, Groups} from "apps/DRAW_PREDICTOR/modules/enums";

export interface ISquad {
	id: number;
	name: string;
	shortName: string;
	confederation: Confederation;
	group?: Groups;
	position?: number;
	pot?: number;
}

export type ISquadsReducer = {
	squads: ISquad[];
};

const initial: ISquadsReducer = {
	squads: [],
};

export const squads = createReducer<ISquadsReducer>({}, initial).on(
	fetchSquadsJsonSuccess,
	(state, payload) => ({
		...state,
		squads: payload,
	})
);
